import React from "react";
import EventPublisher from "../../utils/EventPublisher";
import StoreUpdateEvents from "../../constants/events/StoreUpdateEvents";
import LoadingStates from "../../constants/states/LoadingStates";
import ManageSpaceCalendarView from "../views/SpaceManageCalendarView";
import UIInteractionEvents from "../../constants/events/UIInteractionEvents";
import MemberSpaceCalendarStore from "../../stores/MemberSpaceCalendarStore";
import LoadingView from "../views/LoadingView";


class SpaceManageCalendarContainer extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            "memberSpaceCalendarStoreState": MemberSpaceCalendarStore.getState()
        };
    }

    componentDidMount() {
        this.memberSpaceCalendarStoreSubscriber =
            EventPublisher.subscribe(StoreUpdateEvents.MEMBER_SPACE_CALENDAR_STORE_UPDATED, this.handleStoreUpdate);
        EventPublisher.publish(UIInteractionEvents.RENDERED_VIEW_REQUIRES_MEMBER_SPACE_CALENDAR, {"spaceId": this.props.match.params.id})
    }

    componentWillUnmount() {
        EventPublisher.unsubscribe(this.memberSpaceCalendarStoreSubscriber);
    }

    handleStoreUpdate = (topic, data) => {
        this.setState({
            "memberSpaceCalendarStoreState": MemberSpaceCalendarStore.getState()
        });
    };

    render() {
        if (this.state.memberSpaceCalendarStoreState.loadingState !== LoadingStates.FINISHED_LOADING) {
            return (
                <LoadingView titleText="Loading Space Calendar"/>
            );
        }

        return (
            <ManageSpaceCalendarView
                spaceId={this.props.match.params.id}
                showReservationCrossingSelectionErrorAlert={this.state.memberSpaceCalendarStoreState.showReservationCrossingSelectionErrorAlert}
                currentSelectionRange={this.state.memberSpaceCalendarStoreState.currentSelectionRange}
                blockedDates={this.state.memberSpaceCalendarStoreState.blockedDates}
                reservationRequests={this.state.memberSpaceCalendarStoreState.reservationRequests}
                activeReservations={this.state.memberSpaceCalendarStoreState.activeReservations}
            />
        );
    }

}

export default SpaceManageCalendarContainer;